module.exports = __webpack_public_path__ + "img/hourglass.94839042.svg";